import React, { useState, useEffect } from "react";
import "./style.css";
import httpApis from "../../services/HttpApis";
import { useNavigate } from "react-router-dom";

function UpdateProfile() {
  const [name, setName] = useState("");
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [avatars, setAvatars] = useState([]);
  const [profileId, setProfileId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [isMainProfile, setIsMainProfile] = useState(false);
  // Delete is only offered once we know this isn't the main profile --
  // otherwise it flashed on load and vanished when the data arrived.
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [currentAvatarId, setCurrentAvatarId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedAvatarId = localStorage.getItem("selectedAvatar");
    const storedName = localStorage.getItem("selectedAvatarName");

    if (storedAvatarId) {
      setProfileId(storedAvatarId);
    }

    if (storedName) {
      setName(storedName);
    }

    const fetchAvatars = async () => {
      try {
        const response = await httpApis.getAllAvatarImg();

        if (response?.data?.data) {
          setAvatars(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching avatars:", error);
      }
    };

    const fetchProfileData = async () => {
      try {
        const response = await httpApis.getAllProfile();

        if (response?.data?.data) {
          const currentProfile = response.data.data.find(
            profile => profile.id.toString() === storedAvatarId
          );

          if (currentProfile) {
            if (currentProfile.is_main) {
              setIsMainProfile(true);
            }
            setCurrentAvatarId(currentProfile.avatar_id);
            setSelectedAvatar(currentProfile.avatar_id);
            // The server's name wins over the copy the Edit screen stashed
            // in localStorage (which is only a placeholder while this loads).
            if (currentProfile.name) setName(currentProfile.name);
            setProfileLoaded(true);
          }
        }
      } catch (error) {
        console.error("Error fetching profile data:", error);
      }
    };

    fetchAvatars();
    fetchProfileData();
  }, []);

  const handleUpdate = async () => {
    if (isUpdating) return;

    setIsUpdating(true);

    try {
      const body = {};
      if (name) {
        body.name = name;
      }
      if (selectedAvatar && selectedAvatar !== currentAvatarId) {
        body.avatar = selectedAvatar.toString();
      }

      body.language = "english";
      body.preferences = "";

      const response = await httpApis.postUpdateProfile(profileId, body);
      console.log("Profile updated successfully:", response);

      const currentProfileId = localStorage.getItem("selectedAvatar");
      if (currentProfileId === profileId.toString()) {
        localStorage.setItem('selectedProfileName', name);
      }
      localStorage.removeItem("selectedAvatarName");

      navigate("/profile", { replace: true });
    } catch (error) {
      console.error("Error updating profile:", error);
      setIsUpdating(false);
    }
  };

  const handleDelete = async () => {
    if (isDeleting) return;

    setIsDeleting(true);

    try {
      const response = await httpApis.deleteProfile(profileId);
      console.log("Profile deleted successfully:", response);
      const currentProfileId = localStorage.getItem("selectedAvatar");
      if (currentProfileId === profileId.toString()) {
        localStorage.removeItem('selectedProfileName');
      }

      localStorage.removeItem("selectedAvatar");
      localStorage.removeItem("selectedAvatarName");

      navigate("/profile", { replace: true });
    } catch (error) {
      console.error("Error deleting profile:", error);
      setIsDeleting(false);
    }
  };

  return (
    <div className="profile-container">
      <div className="profile-content">
        <div className="update-header">
          <h1 className="profile-title">Update Profile</h1>
          {profileLoaded && !isMainProfile && (
            <button
              className="delete-btn"
              onClick={handleDelete}
              disabled={isDeleting || isUpdating}
            >
              {isDeleting ? "Deleting..." : "Delete"}
            </button>
          )}
        </div>
        <div className="avatar-container">
          {avatars.map((avatar, index) => (
            <div key={avatar.id || index} className="avatar-wrapper">
              <button
                className={`avatar-button ${selectedAvatar === avatar.id ? "selected" : ""}`}
                onClick={() => setSelectedAvatar(avatar.id)}
                disabled={isUpdating || isDeleting}
              >
                <img
                  src={avatar.image_url || avatar.avatar_img}
                  alt={avatar.name || "avatar"}
                  className="avatar-image"
                />
              </button>
            </div>
          ))}
        </div>

        <div className="profile-input-container">
          <input
            className="profile-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={isUpdating || isDeleting}
          />
        </div>

        <div className="button-container profile-button-spacing">
          <button
            className="profile-button"
            onClick={handleUpdate}
            disabled={isUpdating || isDeleting}
          >
            {isUpdating ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default UpdateProfile;